







































































import Vue from 'vue'
import { mapActions } from 'vuex'
import { Booking } from '@/store/interview/bookings'

export default Vue.extend({
  computed: {
    startsAt(): Date {
      return new Date(this.value.offer!.timeSlot.start!.value)
    },
    endsAt(): Date {
      return new Date(this.value.offer!.timeSlot.end!.value)
    },
    upcoming(): boolean {
      return !!this.value.offer!.upcoming
    },
    present(): boolean {
      return !!this.value.offer!.present
    },
    past(): boolean {
      return !!this.value.offer!.past
    },
    hasTakenPlace(): boolean {
      return !!this.value.offer!.hasTakenPlace
    },
    externalLink(): String | null {
      return this.value.offer!.externalLink || null
    },
    soon(): boolean {
      return !!this.value.offer!.soon
    },
  },
  props: {
    value: {
      required: true,
      type: Object as () => Booking,
    },
  },
  methods: {
    ...mapActions('interview/bookings', ['cancel']),
  },
})
